import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Img from "gatsby-image";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

import Presenter from "../../molecules/presenter/presenter";
import { ReferenciaOrganismos } from "../../../interfaces/ReferenciaContenidos";
import { formatImageAlt } from "../../../shared/utils/stringUtilities";
import useBrowserMode from "../../../shared/hooks/useBrowserMode";

import "./carousel.scss";
import { Link } from "gatsby";

const Carousel = (props: ReferenciaOrganismos) => {
  const [isEdgeOld, setIsEdgeOld] = useState<boolean>(false);
  const [slider, setSlider] = useState<any>();
  const backNext = props.tituloBoton.split(",");
  const [sliderIndex, setSliderIndex] = useState<number>(0);
  const { isBrowser, navigator } = useBrowserMode();
  
  useEffect(() => {
    try {
      if (isBrowser) {
        const indexEdge = navigator.appVersion.indexOf("Edge");
        if (indexEdge >= 0) {
          const edgeName = navigator.appVersion.substring(indexEdge);
          const edgeVersion = parseInt(
            edgeName.substring(edgeName.indexOf("/") + 1)
          );
          setIsEdgeOld(edgeVersion <= 19);
        }
        activeResizeAllMobile();
        window.addEventListener("resize", activeResizeAllMobile);
      }
    } catch (error) {
      setIsEdgeOld(false);
    }
  }, []);

  const goToNext = () => {
    slider.slickGoTo(sliderIndex + 1);
  };

  const goToBack = () => {
    slider.slickGoTo(sliderIndex - 1);
  };

  const isActiveBack = (_true: any, _false: any) =>
    sliderIndex > 0 ? _true : _false;
  const isActiveNext = (_true: any, _false: any) =>
    sliderIndex < props.referenciaContenidos.length - 1 ? _true : _false;

  const settings = {
    arrows: false,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    beforeChange: (_: number, next: number) => setSliderIndex(next),
  };

  const activeResizeAllMobile = () => {
    if (isBrowser) {
      // We execute the same script as before
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    }
  };

  return (
    <div className="o-slider">
      <Slider
        ref={(_slider) => setSlider(_slider)}
        {...settings}
        className="o-slider__carrusel"
      >
        {props.referenciaContenidos.map((value, index) => (
          <div
            className={`o-slider__carrusel__container ${
              isEdgeOld ? " o-slider__carrusel__container--edge" : ""
            }`}
            key={`slide-${index}`}
          >
            <div className="o-slider__carrusel__control-info-side">
              <div className="arrow-content">
                <div className="arrows">
                  <div className="arrows-contain">
                    <span
                      className={`gtmHomeSupBannerAtras ${isActiveBack(
                        "direction active",
                        "direction"
                      )}`}
                      onClick={isActiveBack(goToBack, undefined)}
                    >
                      {backNext[0]}
                    </span>
                    <div
                      className={`gtmHomeSupBannerAtras ${isActiveBack(
                        "arrow icon-arrow-light-left active",
                        "arrow icon-arrow-light-left"
                      )}`}
                      onClick={isActiveBack(goToBack, undefined)}
                    />
                    <div
                      className={`gtmHomeSupBannerAdelante ${isActiveNext(
                        "arrow icon-arrow-light-right active",
                        "arrow icon-arrow-light-right"
                      )}`}
                      onClick={isActiveNext(goToNext, undefined)}
                    />
                    <span
                      className={`gtmHomeSupBannerAdelante ${isActiveNext(
                        "direction active",
                        "direction"
                      )}`}
                      onClick={isActiveNext(goToNext, undefined)}
                    >
                      {backNext[1]}
                    </span>
                  </div>
                  <span
                    className="direction-mobile active"
                    onClick={isActiveNext(goToNext, goToBack)}
                  >
                    {isActiveNext(backNext[1], backNext[0])}
                  </span>
                  <span className="counter">0{sliderIndex + 1}.</span>
                </div>
                <p className="text">
                  {props.referenciaContenidos[sliderIndex].tituloDescripcion}
                </p>
              </div>
              <Presenter
                className={`
                  o-slider__carrusel__container__content 
                  ${
                    value.tipoBanner === "Libro"
                      ? "o-slider__carrusel__container__content__book"
                      : ""
                  }
                `}
                title={value.tituloBanner}
                subtitle={
                  value.descripcion
                    ? documentToReactComponents(value.descripcion.json)
                    : ""
                }
                buttonName={value.tituloBoton}
                buttonLink={value.redireccionBoton}
                categoryName={props.nombreCategoria}
                generalTitle={props.tituloGeneral}
                author={value.referenciaAutor}
              />
            </div>
            <Link to={value.redireccionBoton}>
              {value.imagenesPrincipal[0].fluid ? (
                <Img
                  className={`o-slider__carrusel__container__cover 
                  ${
                    value.tipoBanner === "Libro"
                      ? "o-slider__carrusel__container__cover__book"
                      : ""
                  }`}
                  fluid={value.imagenesPrincipal[0].fluid}
                  alt={
                    value.imagenesPrincipal[0].title
                      ? formatImageAlt(value.imagenesPrincipal[0].title)
                      : `Imagen ${value.tituloBanner}`
                  }
                />
              ) : (
                <img
                  className={`o-slider__carrusel__container__cover 
                  ${
                    value.tipoBanner === "Libro"
                      ? "o-slider__carrusel__container__cover__book"
                      : ""
                  }`}
                  src={value.imagenesPrincipal[0].file.url}
                  alt={
                    value.imagenesPrincipal[0].title
                      ? formatImageAlt(value.imagenesPrincipal[0].title)
                      : `Imagen ${value.tituloBanner}`
                  }
                />
              )}
            </Link>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Carousel;
